document.addEventListener("DOMContentLoaded", function () {

if (window.location.search.indexOf('customer_posted=true') !== -1) {
    window.history.replaceState({}, document.title, window.location.pathname);
}

const countdown = document.querySelector(".cs-countdown");

if (!countdown) return;

const launchDate = countdown.dataset.date;

const days = countdown.querySelector(".days");
const hours = countdown.querySelector(".hours");
const minutes = countdown.querySelector(".minutes");
const seconds = countdown.querySelector(".seconds");

function updateCountdown() {

const target = new Date(launchDate).getTime();

const now = new Date().getTime();

const distance = target - now;

if (distance <= 0) {

countdown.innerHTML = `
<div class="coming-live">
🎉 We are Live!
</div>
`;

return;

}

const d = Math.floor(distance / (1000 * 60 * 60 * 24));

const h = Math.floor(
(distance % (1000 * 60 * 60 * 24)) /
(1000 * 60 * 60)
);

const m = Math.floor(
(distance % (1000 * 60 * 60)) /
(1000 * 60)
);

const s = Math.floor(
(distance % (1000 * 60)) /
1000
);

days.innerHTML = String(d).padStart(2,"0");
hours.innerHTML = String(h).padStart(2,"0");
minutes.innerHTML = String(m).padStart(2,"0");
seconds.innerHTML = String(s).padStart(2,"0");

}

updateCountdown();

setInterval(updateCountdown,1000);

});